import type { LcComponentStatus } from '@/api/lcLearning'
import type { LearnStep } from '../ui-model/types'
import { componentListToStepStatus } from './statusMap'
import { pickComponentLabel, type ComponentLabelFallbacks } from '@/utils/componentLabel'

export function toLearnSteps(
  components: LcComponentStatus[],
  lang: string,
  fallbacks?: ComponentLabelFallbacks,
): {
  sorted: LcComponentStatus[]
  steps: LearnStep[]
} {
  const sorted = [...components].sort((a, b) => a.sortOrder - b.sortOrder)
  const statuses = componentListToStepStatus(sorted)
  const steps: LearnStep[] = sorted.map((comp, i) => ({
    id: comp.configComponentId,
    label: pickComponentLabel(comp, lang, fallbacks),
    circleLabel: String(i + 1),
    status: statuses[i],
  }))
  return { sorted, steps }
}

export function findInitialActiveIndex(
  sorted: LcComponentStatus[],
  stepIdHint?: string,
): number {
  if (stepIdHint) {
    const hinted = sorted.findIndex((c) => c.configComponentId === stepIdHint)
    if (hinted >= 0) return hinted
  }
  const statuses = componentListToStepStatus(sorted)
  const currentIdx = statuses.findIndex((s) => s === 'current')
  return currentIdx
}
